import { render, staticRenderFns } from "./ArticleRegist.vue?vue&type=template&id=78ce97fe&scoped=true&"
import script from "./ArticleRegist.vue?vue&type=script&lang=js&"
export * from "./ArticleRegist.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRegist.vue?vue&type=style&index=0&id=78ce97fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce97fe",
  null
  
)

export default component.exports